import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPagePreviewRoute: InvariantJiraRoute = {
	name: 'communications-status-page-preview',
	path: '/jira/communications/status-page/preview/:pageId',
};
